export const MAX_DEVICE_IMAGES = 4;

export const MAX_IMAGE_SIZE = 1 * (1024 * 1024); // 1MB;

export const ACCEPTED_IMAGE_EXTENSIONS = {
    PNG: 'image/png',
    JPEG: 'image/jpeg',
};
